import type { MultipleChoiceConfig } from '../../../lib/api/types.js';
import { QuestionOptionsFields, emptyQuestionOptions } from '../QuestionOptionsFields.tsx';
import type { FieldViolation } from '../validation.js';

/**
 * The `multiple_choice` configuration form (T100's pattern; the whole file a
 * second Exercise Type adds on the admin side, `ExerciseConfigForm.tsx`).
 *
 * `MultipleChoiceConfig` IS `QuestionOptionsValue` — this file only exists
 * to be the named entry `ExerciseConfigForm`'s registry looks up, matching
 * `note_identification`'s one-form-per-type shape.
 */
interface ConfigFieldsProps {
  value: MultipleChoiceConfig;
  violations: readonly FieldViolation[];
  onChange: (next: MultipleChoiceConfig) => void;
}

export function ConfigFields({ value, violations, onChange }: ConfigFieldsProps) {
  return <QuestionOptionsFields value={value} violations={violations} onChange={onChange} />;
}

export function emptyMultipleChoiceConfig(): MultipleChoiceConfig {
  return emptyQuestionOptions();
}
